<script setup lang="ts">
import { computed } from "vue";

import { drawActions } from "@/action/drawActions";
import { toggleActions } from "@/action/toggleActions";
import { action } from "@/components/action/action";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
import MenuListSubheader from "@/components/ui/MenuList/MenuListSubheader.vue";
import type { ViewportCoordinate } from "@/model/coordinates";
import { useDrawStore } from "@/store/draw";

defineProps<{ position: ViewportCoordinate }>();

defineEmits<{ dummy: [] }>();

const shape = computed(() => useDrawStore().selected?.shape.id);
</script>

<template>
  <MenuList>
    <MenuListItems role="menu" style="width: 300px">
      <MenuListSubheader>{{ $t("contextMenu.general") }}</MenuListSubheader>
      <MenuListItem v-bind="action(toggleActions.hideDraw)" />

      <template v-if="shape">
        <MenuListSubheader>{{ $t("shape.line") }}</MenuListSubheader>
        <MenuListItem v-bind="action(drawActions.removeShape)" />
      </template>
    </MenuListItems>
  </MenuList>
</template>
